import { render, staticRenderFns } from "./FormOpeningBalanceCost.vue?vue&type=template&id=51caf664"
import script from "./FormOpeningBalanceCost.vue?vue&type=script&lang=js"
export * from "./FormOpeningBalanceCost.vue?vue&type=script&lang=js"
import style0 from "./FormOpeningBalanceCost.vue?vue&type=style&index=0&id=51caf664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports